import React, {useState} from "react";
import { useNavigate } from 'react-router-dom';
import VeryconVariants2 from "../../Assets/products_landing/pro1.png"
import VeryconVariants2Left from "../../Assets/products_landing/pro3.png"
import VeryconVariants1Left from "../../Assets/products_landing/pro4.png"
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import Slider from 'react-slick';
import FormModal from "../ProductsLanding/FormModal";

const VeryconPro = () => {
    const sliderSettings2 = {
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    const navigate = useNavigate();

    const img = [
        { title: "Layer 1", src: VeryconVariants2Left },
        { title: "Layer 2", src: VeryconVariants1Left },
    ]
    const [productTitle, setProductTitle] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {

        setIsModalOpen(true)
    };
    return (
        // <section className="bg-light-gradient-white blade-margin-top-sm">
        //     <div className="containers-min mx-auto px-4 py-12">
        //         <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0">
        //             <h3 className="text-center font-gilroy">
        //                 AC Charger Controller - Verycon Pro
        //             </h3>
        //             <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
        //                 VerdeMobility's Verycon Pro Charge Controller is enabling OEMs build safe and purpose
        //                 friendly EV charging solutions that are suitable for different use cases. The controller
        //                 hosts an array of connectivity options, helping.
        //             </p>
        //         </div>

        //         <div className="flex flex-col md:flex-row">
        //             <div className="w-full md:w-1/2">
        //                 <img src={VeryconVariants2} alt="VeryconVariants2" />
        //                 <div className="flex items-center py-2 sm:py-3 gap-3">
        //                     <div onClick={() => {
        //                         navigate('/get-in-touch')
        //                     }}>
        //                         <button
        //                             className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
        //                         >
        //                             <span className="flex justify-center items-center">
        //                                 <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
        //                                 <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
        //                             </span>
        //                             Get Quote
        //                         </button>
        //                         {/* <Button title="Contact Us" /> */}
        //                     </div>

        //                     <div className='group cursor-pointer'>
        //                         <a href="" target="_blank" className='text-gray-600'>
        //                             <button
        //                                 className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6'
        //                             >
        //                                 <span className="flex justify-center items-center">
        //                                     <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
        //                                     <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
        //                                 </span>
        //                                 Brochure
        //                             </button>
        //                         </a>
        //                     </div>
        //                 </div>
        //             </div>
        //             <div className="w-full md:w-1/2"></div>
        //         </div>
        //     </div>
        // </section>
        <section className="bg-light-gradient blade-margin-top-sm">
            <div className="2xl:pb-20 xl:pb-16 lg:pb-12 md:pb-8 pb-0 containers-min mx-auto">
                <h3 className="text-center font-gilroy">
                    AC Charger Controller - Verycon Pro
                </h3>
                <p className="my-3 md:my-5 lg:my-7 text-center font-poppins font-light">
                VerdeMobility's Verycon Pro Charger Controller is enabling OEMs to build safe and purpose friendly EV charging solutions that are suitable for different use cases
                </p>
            </div>
            <div className="flex xLg:flex-row flex-col-reverse gap-3 relative gap-y-6">
                <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center flex-col lg:justify-end px-3 pl-5 lg:pl-20 xl:pl-10">
                    <h5 className="font-semibold font-gilroy">AC Charger Output Configuration</h5>
                    <img src={VeryconVariants2} alt="VeryconVariants2" />
                    <div className="flex items-center py-2 sm:py-3 gap-3 w-full sm:w-2/3">
                        <div onClick={() => {
                            openModal()
                            setProductTitle("AC Charger Controller - Verycon Pro")
                        }}>
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Get Quote
                            </button>
                            {/* <Button title="Contact Us" /> */}
                        </div>

                        <div className='group cursor-pointer'>
                            <a href="https://resources.verdemobility.com/files/Verycon_Pro_Brochure.pdf" target="_blank" className='text-gray-600'>
                                <button
                                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                >
                                    <span className="flex justify-center items-center">
                                        <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                        <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                    </span>
                                    Brochure
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="basis-80 grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
                    {/* Right Gradient Background */}
                    <div className="absolute top-0 bottom-0 right-0 bg-gradient w-24 sm:w-32 md:w-56 lg:w-80 z-0"></div>

                    {/* Slider Container */}
                    <div className="relative z-10 bg-grey rounded-3xl overflow-hidden mx-3 w-full max-w-sm sm:max-w-md md:max-w-[850px] h-[90%] flex items-center justify-center px-4 sm:px-8 md:px-10 lg:px-20">
                        <Slider {...sliderSettings2} className="w-full">
                            {img.map((src, index) => (
                                <div key={index} className="text-center px-2">
                                    <p className="font-poppins text-lg font-medium mb-3">{src.title}</p>
                                    <img
                                        src={src.src}
                                        alt={`slide-${index}`}
                                        className="w-full max-h-[500px] object-contain mx-auto"
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

            </div>
            {isModalOpen && <FormModal isModalOpen={isModalOpen} productTitle={productTitle} setIsModalOpen={setIsModalOpen} />}
        </section>
    );
};

export default VeryconPro;
